import { Experiment } from "@/types/experiment";
import { Plot } from "@/types/plot";
import React from "react";
import ExperimentCard from "./ExperimentCard";

interface ExperimentListProps {
  experiments: Experiment[];
  trialId: string;
  onEditExperiment?: (experiment: Experiment) => void;
  onDeleteExperiment?: (experiment: Experiment) => void;
  onDuplicateExperiment?: (experiment: Experiment, plots: Plot[]) => void;
  canEdit?: boolean;
  canDelete?: boolean;
}

const ExperimentList: React.FC<ExperimentListProps> = ({
  experiments,
  trialId,
  onEditExperiment,
  onDeleteExperiment,
  onDuplicateExperiment,
  canEdit = false,
  canDelete = false,
}) => {
  if (experiments.length === 0) {
    return null; // Empty state is handled by parent component
  }

  return (
    <div className="grid gap-4">
      {experiments.map((experiment) => (
        <ExperimentCard
          key={experiment.id}
          experiment={experiment}
          trialId={trialId}
          onEdit={onEditExperiment}
          onDelete={onDeleteExperiment}
          onDuplicate={onDuplicateExperiment}
          canEdit={canEdit}
          canDelete={canDelete}
        />
      ))}
    </div>
  );
};

export default ExperimentList;
